import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import {
  CONSENT_STORAGE_KEY,
  COOKIE_SETTINGS_EVENT,
  grantAnalytics,
  revokeAnalytics
} from '../utils/analytics';

export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (consent === 'accepted') grantAnalytics();
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    const openBanner = () => setIsVisible(true);
    window.addEventListener(COOKIE_SETTINGS_EVENT, openBanner);
    return () => window.removeEventListener(COOKIE_SETTINGS_EVENT, openBanner);
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_STORAGE_KEY, 'accepted');
    grantAnalytics();
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_STORAGE_KEY, 'declined');
    revokeAnalytics();
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
          className="fixed bottom-0 left-0 right-0 z-[100] p-4 md:p-6 pointer-events-none"
          role="dialog"
          aria-labelledby="cookie-consent-heading"
          aria-describedby="cookie-consent-description"
        >
          <div className="max-w-4xl mx-auto bg-white border border-[#E5E0D8] shadow-2xl rounded-2xl p-5 md:p-6 flex flex-col md:flex-row items-center gap-6 pointer-events-auto">
            <div className="flex-1">
              <h2
                id="cookie-consent-heading"
                className="font-serif text-lg font-medium text-[#2C2A29] mb-1"
              >
                We value your privacy
              </h2>
              <p
                id="cookie-consent-description"
                className="text-sm text-[#6B6661] leading-relaxed"
              >
                We use cookies to analyze how the site is used. Analytics cookies are set only if you
                click Accept All. See our{' '}
                <Link to="/privacy" className="underline hover:text-[#2C2A29]">
                  Privacy Policy
                </Link>
                .
              </p>
            </div>
            <div className="flex items-center gap-3 shrink-0 w-full md:w-auto">
              <button
                onClick={handleDecline}
                className="flex-1 md:flex-none px-5 py-2.5 rounded-xl border border-[#E5E0D8] text-sm font-medium text-[#6B6661] hover:bg-[#FAF8F5] transition-colors"
              >
                Decline
              </button>
              <button
                onClick={handleAccept}
                className="flex-1 md:flex-none px-5 py-2.5 rounded-xl bg-[#2C2A29] text-white text-sm font-medium hover:bg-[#1A1918] transition-colors shadow-sm"
              >
                Accept All
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}